
export const common = {
  // Navigation
  'nav.home': 'Accueil',
  'nav.treatments': 'Traitements',
  'nav.howItWorks': 'Comment ça marche',
  'nav.supervision': 'Supervision',
  'nav.about': 'À propos',
  'nav.bookNow': 'Réserver maintenant',
  'nav.language': 'Langue',

  // Hero
  'hero.badge': 'De vrais médecins. De vrais soins. Une vraie tranquillité d\'esprit.',
  'hero.title.line1': 'Vous méritez un sourire',
  'hero.title.line2': 'Dont vous êtes fier',
  'hero.subtitle1': 'Que ce soit une douleur que vous ignorez, un sourire que vous cachez, ou des coûts qui vous ont fait attendre — vous n\'avez plus à attendre.',
  'hero.subtitle2': 'Nous rendons les soins dentaires de classe mondiale en Turquie sûrs, soutenus et complètement à votre portée — avec un médecin qui surveille chaque étape.',
  'hero.cta.primary': 'Commencer mon voyage',
  'hero.cta.secondary': 'Parler d\'abord à quelqu\'un',
  'hero.feature1': 'Supervisé par un médecin du début à la fin',
  'hero.feature2': 'Des soins adaptés à votre vie et votre budget',
  'hero.feature3': 'Soutenu à chaque étape, près ou loin',

  // Services
  'services.badge': 'Votre voyage commence ici',
  'services.title': 'Des traitements qui changent votre quotidien',
  'services.subtitle': 'Que vous soyez prêt à sourire sans hésitation, manger sans souci, ou simplement vous sentir vous-même à nouveau — nous sommes là pour vous aider',
  'services.cta': 'Explorer tous les traitements',
  'services.swipeHint': 'Glissez pour explorer plus de traitements',
  'services.learnMore': 'En savoir plus',
  'services.startingFrom': 'À partir de',
  'services.perTooth': 'par dent',

  // Service: Dental Implants
  'service.implants.title': 'Implants dentaires',
  'service.implants.desc': 'Mangez, riez et parlez en toute confiance. Sentez-vous vous-même avec des dents qui ressemblent, se sentent et fonctionnent comme vos dents naturelles.',
  // Service: Veneers
  'service.veneers.title': 'Facettes en porcelaine',
  'service.veneers.desc': 'Arrêtez de cacher votre sourire sur les photos. Réveillez-vous chaque jour en aimant ce que vous voyez dans le miroir avec un sourire qui vous ressemble enfin.',

  // Service: Smile Makeover
  'service.smile.title': 'Relooking du sourire',
  'service.smile.desc': 'Transformez ce que vous ressentez pour vous-même. Un relooking complet du sourire conçu autour de votre visage, votre vie et la confiance que vous méritez.',

  // Service: Orthodontics
  'service.orthodontics.title': 'Orthodontie',
  'service.orthodontics.desc': 'Redressez vos dents sans gêne. Un traitement discret qui s\'adapte à votre style de vie et vous donne le sourire que vous avez toujours voulu.',

  // Service: Whitening
  'service.whitening.title': 'Blanchiment dentaire',
  'service.whitening.desc': 'Sentez-vous confiant dans chaque conversation. Un sourire plus brillant et plus blanc qui vous fait vous sentir bien chaque fois que vous parlez.',

  // Service: Root Canal
  'service.root.title': 'Traitement de canal',
  'service.root.desc': 'Arrêtez de vivre avec des douleurs dentaires. Sauvez votre dent naturelle et retrouvez le plaisir de vivre sans inconfort ni inquiétude constants.',

  // Service: Crowns
  'service.crowns.title': 'Couronnes dentaires',
  'service.crowns.desc': 'Protégez et restaurez les dents endommagées pour pouvoir manger ce que vous aimez à nouveau. Des couronnes solides et d\'apparence naturelle qui durent des années.',

  // Service: All-on-4
  'service.allon4.title': 'Implants All-on-4',
  'service.allon4.desc': 'Retrouvez votre vie en une seule journée. Un ensemble complet de dents permanentes qui vous permettent de manger, sourire et vivre sans limites ni embarras.',

  // How It Works
  'how.badge': 'Processus simple',
  'how.title': 'Comment ça marche',
  'how.subtitle': 'Quatre étapes simples pour obtenir des soins dentaires de classe mondiale en toute transparence',
  'how.cta': 'Commencer votre voyage',

  'how.step1.number': '01',
  'how.step1.title': 'Réservez votre traitement',
  'how.step1.desc': 'Choisissez votre traitement dentaire et téléchargez vos radiographies ou scanners. Notre équipe examinera et créera un plan de traitement personnalisé.',

  'how.step2.number': '02',
  'how.step2.title': 'Choisissez la supervision',
  'how.step2.desc': 'Sélectionnez votre option de supervision préférée: médecin tiers indépendant, votre propre dentiste (payé 10%), ou notre expert interne.',

  'how.step3.number': '03',
  'how.step3.title': 'Recevez le traitement en transparence',
  'how.step3.desc': 'Recevez votre traitement dans notre clinique accréditée JCI. Votre superviseur examine toutes les radiographies, scanners et progrès du traitement en temps réel.',

  'how.step4.number': '04',
  'how.step4.title': 'Suivi des soins',
  'how.step4.desc': 'Continuez les soins avec votre dentiste qui a une connaissance complète de votre traitement. Nous fournissons tous les dossiers et un soutien continu.',

  // Supervision
  'supervision.badge': 'Vous êtes protégé à chaque étape',
  'supervision.title': 'Inquiet d\'aller à l\'étranger pour des soins dentaires?',
  'supervision.subtitle': 'Cette inquiétude est tout à fait valable — et c\'est exactement pourquoi nous avons construit cela. Chaque patient bénéficie d\'un superviseur dédié qui surveille son traitement du premier au dernier jour.',
  'supervision.swipeHint': 'Glissez pour explorer les options',
  'supervision.chooseOption': 'Choisissez cette option lors de la réservation',

  'supervision.option1.title': 'Médecin tiers indépendant',
  'supervision.option1.badge': 'Le plus fiable',
  'supervision.option1.desc': 'Quelqu\'un dans votre coin qui ne répond qu\'à vous — pas à la clinique. Ils examinent chaque scan, approuvent chaque étape et s\'assurent que rien n\'est manqué.',
  'supervision.option1.feature1': 'Examine vos radiographies avant que quoi que ce soit ne commence',
  'supervision.option1.feature2': 'Approuve votre plan de traitement de manière indépendante',
  'supervision.option1.feature3': 'Vérifie à chaque étape de vos soins',
  'supervision.option1.feature4': 'Confirme que le résultat final répond à la norme',
  'supervision.option1.feature5': 'Zéro conflit d\'intérêts — ils travaillent pour vous',
  'supervision.option1.pricing': 'Ce que vous obtenez: Supervision indépendante complète',

  'supervision.option2.title': 'Votre propre dentiste',
  'supervision.option2.badge': 'Le plus confortable',
  'supervision.option2.desc': 'Le dentiste en qui vous avez déjà confiance reste partie de votre voyage. Ils connaissent votre historique, ils vous connaissent — et restent informés à chaque étape.',
  'supervision.option2.feature1': 'Votre dentiste reçoit tous les dossiers et scanners',
  'supervision.option2.feature2': 'Tenu au courant à chaque étape du traitement',
  'supervision.option2.feature3': 'Gère votre suivi à domicile',
  'supervision.option2.feature4': 'Gagne 10% du coût du traitement pour son temps',
  'supervision.option2.feature5': 'Continuité transparente — pas de recommencement',
  'supervision.option2.pricing': 'Ce que vous obtenez: Soins familiers, sans lacunes',

  'supervision.option3.title': 'Notre expert interne',
  'supervision.option3.badge': 'Inclus',
  'supervision.option3.desc': 'Un spécialiste senior avec plus de 15 ans d\'expérience surveille votre traitement sur place. Vous n\'êtes jamais juste un patient — vous êtes une priorité.',
  'supervision.option3.feature1': 'Plus de 15 ans d\'expérience spécialisée',
  'supervision.option3.feature2': 'Présent à la clinique tout au long de vos soins',
  'supervision.option3.feature3': 'Répond immédiatement si quelque chose ne va pas',
  'supervision.option3.feature4': 'Maintient chaque étape au plus haut niveau',
  'supervision.option3.feature5': 'Déjà inclus — aucun coût supplémentaire pour vous',
  'supervision.option3.pricing': 'Ce que vous obtenez: Des yeux d\'expert, toujours présents',

  'supervision.why.title': 'Vous ne devriez pas avoir à simplement espérer le meilleur',
  'supervision.why.desc': 'Aller à l\'étranger pour un traitement dentaire demande du courage. Vous faites confiance à des personnes que vous n\'avez jamais rencontrées, dans un pays que vous ne connaissez peut-être pas, avec quelque chose d\'aussi personnel que votre sourire. Nous avons construit notre système de supervision parce que nous croyons que vous méritez plus qu\'une promesse — vous méritez une vraie personne qui surveille chaque décision prise concernant vos soins. Pas une liste de contrôle. Pas une brochure. Un être humain qui vous est redevable.',

  // CTA
  'cta.title.line1': 'Votre sourire a',
  'cta.title.line2': 'Attendu assez longtemps',
  'cta.subtitle1': 'Nous savons que ce n\'est pas facile de franchir cette étape. L\'incertitude, les questions, les "et si" — nous les entendons tous les jours. C\'est exactement pourquoi nous sommes là.',
  'cta.subtitle2': 'Votre première conversation est gratuite, sans pression et entièrement à vos conditions. Parlez-nous simplement — nous nous occuperons du reste.',
  'cta.button.primary': 'Je suis prêt à parler',
  'cta.button.secondary': 'Discuter sur WhatsApp',
  'cta.badge1': 'De vrais médecins. De vrais soins.',
  'cta.badge2': 'Pas de pression. Pas de précipitation.',
  'cta.badge3': 'Vous êtes soutenu à chaque étape.',
  'cta.badge4': 'De vrais résultats. De vraies personnes.',

  // Footer
  'footer.brand.desc': 'Nous croyons que tout le monde mérite de se sentir confiant dans son sourire. Nous sommes là pour rendre cela possible — en toute sécurité, honnêtement et avec un vrai médecin à vos côtés.',
  'footer.cta': 'Réserver une consultation',
  'footer.treatments': 'Traitements',
  'footer.company': 'Entreprise',
  'footer.resources': 'Ressources',
  'footer.phone': 'Téléphone',
  'footer.email': 'E-mail',
  'footer.location': 'Emplacement',
  'footer.locationValue': 'Istanbul, Turquie',
  'footer.copyright': '© {{year}} Plexus Alliance. Tous droits réservés.',
  'footer.poweredBy': 'Propulsé par Readdy',

  // About page
  'about.hero.badge': 'Notre histoire',
  'about.hero.title': 'Nous avons créé le filet de sécurité qui manquait au tourisme dentaire',
  'about.hero.subtitle': 'Plexus Alliance a été fondée sur une conviction simple : les patients méritent une voix indépendante dans leur propre traitement — surtout loin de chez eux.',
  'about.mission.badge': 'Notre mission',
  'about.mission.title': 'Des soins dentaires transparents et supervisés pour chaque patient, partout.',
  'about.mission.desc': 'Nous connectons les patients aux meilleures cliniques dentaires d\'Istanbul tout en fournissant la couche de supervision indépendante que la plupart des entreprises de tourisme dentaire n\'offrent tout simplement pas.',
  'about.values.badge': 'Ce en quoi nous croyons',
  'about.values.title': 'Nos valeurs fondamentales',
  'about.value1.title': 'Indépendance',
  'about.value1.desc': 'Nos superviseurs ne répondent qu\'à vous — jamais à la clinique.',
  'about.value2.title': 'Transparence',
  'about.value2.desc': 'Chaque dossier, chaque scan, chaque décision — entièrement visible pour vous.',
  'about.value3.title': 'Continuité',
  'about.value3.desc': 'Vos soins ne s\'arrêtent pas quand vous montez dans votre avion.',
  'about.value4.title': 'Accessibilité',
  'about.value4.desc': 'Les soins dentaires de classe mondiale ne devraient pas être un privilège. Nous les rendons accessibles.',

  // Treatments page
  'treatments.hero.badge': 'Tous les traitements',
  'treatments.hero.title': 'Trouvez votre traitement',
  'treatments.hero.subtitle': 'Des implants simples aux relookings complets du sourire — chaque traitement est supervisé, transparent et au juste prix.',
  'treatments.filter.all': 'Tous les traitements',
  'treatments.filter.implants': 'Implants',
  'treatments.filter.cosmetic': 'Cosmétique',
  'treatments.filter.orthodontics': 'Orthodontie',
  'treatments.filter.restorative': 'Restauration',
  'treatments.cta.title': 'Vous ne savez pas quel traitement vous convient?',
  'treatments.cta.desc': 'Dites-nous ce qui vous dérange — nous examinerons votre cas gratuitement et recommanderons la bonne voie.',
  'treatments.cta.button': 'Obtenir une évaluation gratuite',

  // Book Treatment page
  'book.hero.badge': 'Commencez votre voyage',
  'book.hero.title': 'Réservez votre traitement',
  'book.hero.subtitle': 'Remplissez les détails ci-dessous et nous vous répondrons dans quelques heures avec un plan personnalisé.',
  'book.form.name': 'Nom complet',
  'book.form.email': 'Adresse e-mail',
  'book.form.phone': 'Téléphone / WhatsApp',
  'book.form.treatment': 'Traitement souhaité',
  'book.form.supervision': 'Préférence de supervision',
  'book.form.message': 'Dites-nous en plus (optionnel)',
  'book.form.submit': 'Envoyer ma demande',
  'book.form.submitting': 'Envoi en cours...',
  'book.form.success': 'Demande envoyée ! Nous vous contacterons dans quelques heures.',

  // Partner Registration page
  'partner.hero.badge': 'Partenariat',
  'partner.hero.title': 'Rejoignez le réseau Plexus Alliance',
  'partner.hero.subtitle': 'Êtes-vous dentiste, clinique ou professionnel de santé ? Devenez partenaire et gagnez en aidant vos patients à accéder à des soins de classe mondiale.',
  'partner.form.submit': 'Soumettre la candidature',

  // How It Works page
  'hiw.hero.badge': 'Le processus',
  'hiw.hero.title': 'Comment ça marche',
  'hiw.hero.subtitle': 'De votre premier message à votre dernier contrôle — voici exactement ce qui se passe, étape par étape.',
  'hiw.faq.title': 'Vous avez encore des questions ?',
  'hiw.cta.title': 'Prêt à franchir le premier pas ?',
  'hiw.cta.subtitle': 'Tout commence par un seul message. Dites-nous ce dont vous avez besoin — nous nous occupons du reste.',
  'hiw.cta.button': 'Commencer mon voyage',

  // Supervision page
  'sup.hero.badge': 'Votre protection',
  'sup.hero.title': 'Supervision médicale',
  'sup.hero.subtitle': 'La seule chose que la plupart des entreprises de tourisme dentaire n\'offrent pas — et la seule chose qui fait toute la différence.',
  'sup.why.title': 'La plupart des cliniques travaillent pour elles-mêmes. Nous travaillons pour vous.',
  'sup.options.title': 'Trois façons de rester protégé',
  'sup.pillars.title': 'Ce que reçoit chaque patient supervisé',
  'sup.compare.title': 'Avec supervision vs. sans',
  'sup.faq.title': 'Questions sur la supervision',
  'sup.cta.title': 'Votre santé mérite une voix indépendante.',
  'sup.cta.button': 'Réserver avec supervision',

  // Common UI
  'common.learnMore': 'En savoir plus',
  'common.bookNow': 'Réserver maintenant',
  'common.startJourney': 'Commencer mon voyage',
  'common.getStarted': 'Commencer',
  'common.contactUs': 'Nous contacter',
  'common.readMore': 'Lire la suite',
  'common.viewAll': 'Voir tout',
  'common.close': 'Fermer',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.loading': 'Chargement...',
  'common.error': 'Quelque chose s\'est mal passé. Veuillez réessayer.',
  'common.required': 'Ce champ est obligatoire',
  'common.optional': 'Optionnel',
  'common.saving': 'Économies de',
  'common.perTooth': 'par dent',
  'common.included': 'Inclus',
  'common.mostTrusted': 'Le plus fiable',
  'common.mostComfortable': 'Le plus confortable',
  'common.yearsExperience': 'ans d\'expérience',
  'common.patients': 'patients',
  'common.countries': 'pays',
  'common.savings': 'économies',
};

export default common;
